// Mock data for TD Homes website

export const heroData = {
  title: "L'expertise digitale au service de votre patrimoine immobilier",
  subtitle: "Accompagnement haut de gamme dédié à la performance locative de vos hébergements touristiques",
  cta: "Demander un devis",
  ctaSecondary: "Découvrir nos services",
  image: "https://images.pexels.com/photos/210604/pexels-photo-210604.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const servicesData = [
  {
    id: 1,
    title: "Hôtels",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1630660664869-c9d3cc676880?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxob3RlbCUyMGJlZHJvb20lMjB3aGl0ZSUyMHNoZWV0cyUyMGVsZWdhbnR8ZW58MHx8fHwxNzcxNDM0NjQyfDA&ixlib=rb-4.1.0&q=85",
    description: "Optimisez votre présence en ligne et maximisez vos réservations",
    features: [
      "Gestion complète des canaux de distribution (OTA)",
      "Optimisation de votre visibilité sur Booking, Expedia, Airbnb",
      "Synchronisation automatique de vos disponibilités",
      "Stratégie de pricing dynamique selon la saisonnalité",
      "Gestion des avis clients et e-réputation",
      "Reporting détaillé de vos performances"
    ]
  },
  {
    id: 2,
    title: "Conciergeries",
    icon: "Hotel",
    image: "./conciergerie-accueil.png",
    description: "Développez votre portefeuille et augmentez votre rentabilité",
    features: [
      "Distribution multi-canal de votre catalogue",
      "Gestion centralisée des réservations",
      "Outils de Revenue Management dédiés",
      "Automatisation des processus de réservation",
      "Support pour la gestion de vos relations clients",
      "Formation de vos équipes aux meilleures pratiques OTA"
    ]
  },
  {
    id: 3,
    title: "Particuliers",
    icon: "Home",
    image: "./particulier-femme.webp",
    description: "Maximisez les revenus de votre bien sans contraintes",
    features: [
      "Option 1 - Gestion digitale complète de votre bien",
      "Création et optimisation de vos annonces",
      "Gestion des prix selon la demande et les événements locaux",
      "Traitement des demandes et réservations",
      "Option 2 - Conseil et accompagnement personnalisé",
      "Formation à l'utilisation des plateformes OTA"
    ]
  }
];

export const valuesData = [
  {
    id: 1,
    icon: "TrendingUp",
    title: "Performance",
    description: "Maximisation de votre taux d'occupation et de vos revenus grâce à des stratégies de Revenue Management éprouvées"
  },
  {
    id: 2,
    icon: "Award",
    title: "Expertise",
    description: "Maîtrise complète des algorithmes et des bonnes pratiques des plateformes Airbnb, Booking.com et Expedia"
  },
  {
    id: 3,
    icon: "Shield",
    title: "Confiance",
    description: "Transparence totale dans notre gestion et communication régulière sur les performances de vos biens"
  },
  {
    id: 4,
    icon: "Sparkles",
    title: "Valorisation",
    description: "Mise en valeur professionnelle de vos propriétés pour séduire votre clientèle cible"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Marie Dubois",
    role: "Propriétaire d'hôtel boutique",
    content: "Depuis que TD Homes gère notre distribution en ligne, notre taux d'occupation a augmenté de 35%. Leur expertise des OTA est remarquable.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"
  },
  {
    id: 2,
    name: "Jean-Pierre Martin",
    role: "Directeur de conciergerie",
    content: "Une équipe professionnelle qui comprend vraiment les enjeux de la location saisonnière. Le ROI est au rendez-vous.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150"
  },
  {
    id: 3,
    name: "Sophie Laurent",
    role: "Propriétaire particulier",
    content: "Je peux enfin profiter de mon bien sans me soucier de la gestion. TD Homes s'occupe de tout avec une efficacité remarquable.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150"
  }
];

export const faqData = [
  {
    id: 1,
    question: "Quelles plateformes OTA gérez-vous ?",
    answer: "Nous gérons l'ensemble des principales plateformes de réservation en ligne : Airbnb, Booking.com, Expedia, Hotels.com, Vrbo, et bien d'autres selon vos besoins spécifiques."
  },
  {
    id: 2,
    question: "Quel est le délai pour voir des résultats ?",
    answer: "Les premiers résultats sont généralement visibles dès le premier mois avec une optimisation de votre visibilité. L'amélioration significative des performances intervient généralement sous 2-3 mois."
  },
  {
    id: 3,
    question: "Proposez-vous un accompagnement personnalisé ?",
    answer: "Absolument. Chaque client bénéficie d'un accompagnement sur-mesure adapté à ses objectifs et à la typologie de ses biens. Nous croyons en une approche personnalisée."
  },
  {
    id: 4,
    question: "Comment assurez-vous la transparence de votre gestion ?",
    answer: "Vous avez accès à un tableau de bord détaillé en temps réel et recevez des rapports réguliers sur les performances de vos biens (réservations, revenus, taux d'occupation, avis clients)."
  }
];

export const contactInfo = {
  email: "contact@td-homes.com",
  phone: "+33 7 49 19 80 76",
  address: "Paris, France"
};

export const aboutData = {
  title: "À propos de TD Homes",
  subtitle: "Votre partenaire de confiance pour la gestion de votre patrimoine immobilier",
  description: "TD Homes crée le lien entre la gestion locative traditionnelle et la puissance des outils digitaux. Nous déchargeons les propriétaires des contraintes opérationnelles liées à la commercialisation en ligne afin qu'ils puissent se concentrer sur l'essentiel : développer leur activité, soigner l'expérience sur place et faire croître leur parc immobilier.",
  image: "./about-td-homes.png",
  stats: [
    { value: "500+", label: "Propriétés gérées" },
    { value: "95%", label: "Taux de satisfaction" },
    { value: "+40%", label: "Revenus en moyenne" },
    { value: "24/7", label: "Support client" }
  ]
};
